import { useCallback, useState } from 'react';

const STORAGE_KEY = 'sorai-erp:sidebar-collapsed';

function readInitial(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Desktop sidebar collapsed state, remembered per browser. */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(readInitial);

  const toggle = useCallback(() => {
    setCollapsed((previous) => {
      const next = !previous;
      try {
        window.localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        // Storage unavailable (private mode, blocked): keep in-memory state only.
      }
      return next;
    });
  }, []);

  return { collapsed, toggle };
}
